import { render, staticRenderFns } from "./HeadlineSection.vue?vue&type=template&id=0f3416c8"
import script from "./HeadlineSection.vue?vue&type=script&lang=js"
export * from "./HeadlineSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports